import styled from "styled-components";
import { useEffect, useState } from "react";

import { wibDateIso, wibTime, formatDate } from "./dateFormat";
import { useT } from "./i18n";

const Wrap = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0.4rem;
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.9);
  font-variant-numeric: tabular-nums;
`;

const Time = styled.strong`
  font-weight: 700;
  color: #ffffff;
`;

// Live WIB (Asia/Jakarta) clock, e.g. "Kam, 02 Jul 2026 · 14:30:45 WIB". Ticks every second.
const Clock = (props) => {
  const { lang } = useT();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <Wrap>
      {formatDate(wibDateIso(now), lang)}
      <Time>{wibTime(now)} WIB</Time>
    </Wrap>
  );
};

export default Clock;
